import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { showNevisPopupAction } from '../../actions';
import { INevisEditPasskeysProps } from '../../types';
import {
    NevisPasskeysSwissRenamePopup
} from '../../components/NevisPasskeysSwissRenamePopup/NevisPasskeysSwissRenamePopup';

export const useRenamePasskey = ({
    data,
    fetchPortlet,
    portletType,
    index,
    tkPrefix
}: INevisEditPasskeysProps) => {
    const dispatch = useDispatch();

    return useCallback (() => {
        let nameAuth = '';
        data?.fidoAuthenticators?.forEach((el: { name: string }, ind: any) => {
            if (ind === index) {
                nameAuth = el.name;
            }
        });

        dispatch(showNevisPopupAction({
            title: `${tkPrefix}passkeys.rename.passkey`,
            acceptBtnText: `${tkPrefix}passkeys.save`,
            declineBtnText: `${tkPrefix}passkeys.cancel`,
            nameAuth,
            index,
            fidoAuthenticators: data?.fidoAuthenticators,
            fetchPortlet,
            portletType,
            tkPrefix
        }, NevisPasskeysSwissRenamePopup));
    }, [data?.fidoAuthenticators, dispatch, fetchPortlet, index, portletType, tkPrefix]);
};
